import { render, staticRenderFns } from "./Object3d.vue?vue&type=template&id=d996191c&scoped=true&"
import script from "./Object3d.vue?vue&type=script&lang=js&"
export * from "./Object3d.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d996191c",
  null
  
)

export default component.exports